import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-33ec43fc");

_pushScopeId("data-v-33ec43fc");

var _hoisted_1 = {
  class: "has-logo"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sidebar_item = _resolveComponent("sidebar-item");

  var _component_el_menu = _resolveComponent("el-menu");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    "wrap-class": "scrollbar-wrapper"
  }, {
    default: _withId(function () {
      return [_createVNode(_component_el_menu, {
        "default-openeds": $setup.openFolders,
        "default-active": $options.activeMenu,
        collapse: !_ctx.sidebar.opened,
        "background-color": $setup.cssVariables.menuBg,
        "text-color": $setup.cssVariables.menuFontColor,
        "active-text-color": $setup.cssVariables.menuFontColorActive,
        mode: "vertical",
        router: true
      }, {
        default: _withId(function () {
          return [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, function (menu) {
            return _openBlock(), _createBlock(_component_sidebar_item, {
              key: menu.path,
              item: menu,
              "base-path": menu.path
            }, null, 8
            /* PROPS */
            , ["item", "base-path"]);
          }), 128
          /* KEYED_FRAGMENT */
          ))];
        }),
        _: 1
        /* STABLE */

      }, 8
      /* PROPS */
      , ["default-openeds", "default-active", "collapse", "background-color", "text-color", "active-text-color"])];
    }),
    _: 1
    /* STABLE */

  })]);
});